const loaders = {
  json: () => import("highlight.js/lib/languages/json"),
  xml: () => import("highlight.js/lib/languages/xml"),
};

const aliases = { html: "xml" };

export function resolveLanguage(name) {
  const language = aliases[name] || name;

  return loaders[language] ? language : null;
}

export async function highlightCode(code, name) {
  const language = resolveLanguage(name);

  if (!language) {
    return null;
  }

  const [{ default: hljs }, { default: definition }] = await Promise.all([
    import("highlight.js/lib/core"),
    loaders[language](),
  ]);

  if (!hljs.getLanguage(language)) {
    hljs.registerLanguage(language, definition);
  }

  return hljs.highlight(code, { language }).value;
}
